export default "__VITE_ASSET__Dqndt7HY__"